module.exports = __webpack_public_path__ + "/bc35899cc10d4f1cfd3d1ec162ef121f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/header/plus_icon@2x.png
 ** module id = 704
 ** module chunks = 0
 **/